import React, { useContext } from 'react';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { useGetSum } from '@shared/hooks/useGetSum';

import cls from './PaymentItem.module.css';
import { fetchAccounts, fetchDataForEdit } from '../../../../store/slices/paymentSlice/action';
import { BankIcon } from '../../../../TemporaryConmonents/Accounts/BankIcon';
import { Context } from '../PaymentsList';

const styleStatusMapping = {
    0: 'black',
    1: 'red',
    2: 'orange',
};
export const PaymentItem = ({ payment, setAddModalState }) => {
    const { setCurrentPayment, setIsOpen } = useContext(Context);

    const { t } = useTranslation();
    const isArchiveAccount = payment.account.is_archive;

    const dispatch = useDispatch();

    // todo move in shared/lib getDateWithoutUtc
    const dateWithoutUtc = moment(payment.payment_date.split('T')[0])
        .locale(LOCALE)
        .format(`DD MMM YYYY ${t('PaymentItem.dateWithoutUtc')}.`);

    const allAccounts = useSelector((state) => state.paymentReducer.accountsSelectList);
    const allExpense = useSelector((state) => state.paymentReducer.expenseList);
    const allIncome = useSelector((state) => state.paymentReducer.incomeList);
    const allPartners = useSelector((state) => state.paymentReducer.partnersSelectList);
    const allEstimates = useSelector((state) => state.paymentReducer.estimatesSelectList);
    const { float, kopecks } = useGetSum(payment.sum);

    const receivedSum = {
        float: 0,
        kopecks: 0,
    };

    if (payment.type === 'transfer') {
        const { float, kopecks } = useGetSum(payment.received_sum);
        receivedSum.float = float;
        receivedSum.kopecks = kopecks;
    }

    let firstAccount = '';
    let secondAccount = '';

    let isIntegrationFirstAccount = false;
    let isIntegrationSecondAccount = false;

    if (payment.account.integration) {
        isIntegrationFirstAccount = true;
        firstAccount = payment.account.title;
    } else {
        firstAccount = payment.account.title;
    }

    if (payment.type === 'transfer') {
        if (payment.correspondent.integration) {
            isIntegrationSecondAccount = true;
            secondAccount = payment.correspondent.title;
        } else {
            secondAccount = payment.correspondent.title;
        }
    }

    const objectsEstimates = payment.sum_divisions
        .map(({ _, estimate, project }) => {
            if (estimate.name !== undefined) {
                return `${project.name} / ${estimate.name}`;
            }
            if (project.name === undefined) {
                return '';
            }
            return `${project.name}`;
        })
        .join(', ');

    let correspondent = '';

    if (payment.correspondent === undefined) {
        correspondent = '—';
    } else if (payment.correspondent.name !== undefined) {
        correspondent = payment.correspondent.name;
    } else {
        correspondent = '';
    }

    const repeatPayment = async (e) => {
        e.stopPropagation();
        setCurrentPayment(payment);
        if (allAccounts.length) {
            setAddModalState((prevState) => ({
                ...prevState,
                mode: payment.type,
                isOpen: true,
                step: 1,
                isBetweenAccount: payment.type === 'transfer',
                addPaymentMode: 'repeat',
            }));
        } else {
            loader.show();
            const callback = () => {
                setAddModalState((prevState) => ({
                    ...prevState,
                    mode: payment.type,
                    isOpen: true,
                    step: 1,
                    isBetweenAccount: payment.type === 'transfer',
                    addPaymentMode: 'repeat',
                }));
                loader.hide();
            };
            await dispatch(fetchAccounts());

            await callback();
        }
    };

    const onClickItem = async () => {
        if (payment.status.value === 'unsettled') {
            if (isArchiveAccount) {
                swal({
                    text: t('PaymentItem.onClickItem.swal.text'),
                    cancel: false,
                    confirm: true,
                    button: {
                        text: t('button.ok.text'),
                        value: true,
                        visible: true,
                        className: 'btn btn-primary',
                    },
                });
                return;
            }
            setCurrentPayment(payment);
            if (allAccounts.length) {
                setAddModalState((prevState) => ({
                    ...prevState,
                    mode: payment.type,
                    isOpen: true,
                    step: 1,
                    isBetweenAccount: payment.type === 'transfer',
                    addPaymentMode: 'distribution',
                }));
            } else {
                loader.show();
                const callback = () => {
                    setAddModalState((prevState) => ({
                        ...prevState,
                        mode: payment.type,
                        isOpen: true,
                        step: 1,
                        isBetweenAccount: payment.type === 'transfer',
                        addPaymentMode: 'distribution',
                    }));
                    loader.hide();
                };
                await dispatch(fetchAccounts());

                await callback();
            }
        } else if (
            allAccounts.length &&
            allIncome.length &&
            allPartners.length &&
            allEstimates.length &&
            allExpense.length
        ) {
            setCurrentPayment(payment);
            setIsOpen(true);
        } else {
            loader.show();
            const callback = () => {
                setCurrentPayment(payment);
                setIsOpen(true);
                loader.hide();
            };

            await dispatch(fetchDataForEdit());
            await callback();
        }
    };

    const getCurrencyPlacement = (currencySign) => {
        if (!currencySign) {
            return { prefix: '', suffix: '' };
        }

        const suffixLocales = new Set(['ru', 'de', 'tr']);
        const localeSuffix = suffixLocales.has((LOCALE || 'ru').toLowerCase());
        const isSuffix = localeSuffix;

        return isSuffix
            ? { prefix: '', suffix: ` ${currencySign}` }
            : { prefix: currencySign, suffix: '' };
    };

    const getDecimalSeparator = () => {
        const sample = numberFormatter.formatNumber(1.1, 1, false);
        const separator = sample.replace(/[0-9]/g, '').charAt(0);
        return separator || ',';
    };

    const renderMoneyParts = (valueFloat, valueKopecks, currencySign) => {
        const { prefix, suffix } = getCurrencyPlacement(currencySign);
        const decimalSeparator = getDecimalSeparator();

        return (
            <>
                {prefix}
                {valueFloat}
                {decimalSeparator}
                <span className={classNames(cls.kopecks)}>{valueKopecks}</span>
                {suffix}
            </>
        );
    };

    return (
        <div onClick={onClickItem} className={classNames(cls.wrapper)}>
            <div>{dateWithoutUtc}</div>
            <div className={classNames(cls.textWrapper)}>{payment.target}</div>
            <div className={classNames(cls.sum, cls[payment.type], cls.textWrapper)}>
                <span className={classNames(cls.textWrapper)}>
                    {payment.type === 'debit' ? '+' : '-'}
                    {renderMoneyParts(float, kopecks, payment.account.currency.sign)}
                </span>
                {payment.type === 'transfer' && (
                    <span className={classNames(cls.textWrapper)}>
                        +
                        {renderMoneyParts(
                            receivedSum.float,
                            receivedSum.kopecks,
                            payment.correspondent.currency.sign
                        )}
                    </span>
                )}
            </div>
            <div
                className={classNames(cls.status, {
                    [cls[styleStatusMapping[payment.status.type]]]: payment.status.type,
                })}
            >
                {payment.status.display && payment.status.display}
            </div>
            <div className={classNames(cls.textWrapper)}>{correspondent}</div>
            <div className={classNames(cls.textWrapper)}>{objectsEstimates}</div>
            <div className={classNames(cls.account)}>
                <span
                    className={classNames(cls.textWrapper, {
                        [cls.integrationAccount]: isIntegrationFirstAccount,
                    })}
                >
                    {isIntegrationFirstAccount && (
                        <div className={classNames(cls.iconBank)}>
                            <BankIcon type={payment.account.integration} width={18} height={16} />
                        </div>
                    )}
                    {firstAccount}
                </span>
                {!!secondAccount && (
                    <span
                        className={classNames(cls.textWrapper, {
                            [cls.integrationAccount]: isIntegrationSecondAccount,
                        })}
                    >
                        {isIntegrationSecondAccount && (
                            <div className={classNames(cls.iconBank)}>
                                <BankIcon
                                    type={payment.correspondent.integration}
                                    width={18}
                                    height={16}
                                />
                            </div>
                        )}
                        {secondAccount}
                    </span>
                )}
            </div>
            <div onClick={repeatPayment} className={classNames(cls.repeat)}>
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M14.4697 5.09467C14.7626 4.80178 15.2374 4.80178 15.5303 5.09467L17.7803 7.34467C18.0732 7.63756 18.0732 8.11244 17.7803 8.40533L15.5303 10.6553C15.2374 10.9482 14.7626 10.9482 14.4697 10.6553C14.1768 10.3624 14.1768 9.88756 14.4697 9.59467L16.1893 7.875L14.4697 6.15533C14.1768 5.86244 14.1768 5.38756 14.4697 5.09467Z"
                        fill="#28B57A"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M6.74776 7.12501L6.75 7.125H16.5C16.9142 7.125 17.25 7.46079 17.25 7.875C17.25 8.28922 16.9142 8.625 16.5 8.625H6.75118C5.95605 8.62766 5.19422 8.94469 4.63196 9.50696C4.06969 10.0692 3.75265 10.8311 3.75 11.6262V12.375C3.75 12.7892 3.41421 13.125 3 13.125C2.58579 13.125 2.25 12.7892 2.25 12.375V11.6228C2.25356 10.431 2.72858 9.28902 3.5713 8.4463C4.41402 7.60358 5.55598 7.12857 6.74776 7.12501ZM9.53033 13.3447C9.82322 13.6376 9.82322 14.1124 9.53033 14.4053L7.81066 16.125L9.53033 17.8447C9.82322 18.1376 9.82322 18.6124 9.53033 18.9053C9.23744 19.1982 8.76256 19.1982 8.46967 18.9053L6.21967 16.6553C5.92678 16.3624 5.92678 15.8876 6.21967 15.5947L8.46967 13.3447C8.76256 13.0518 9.23744 13.0518 9.53033 13.3447Z"
                        fill="#28B57A"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M21 10.875C21.4142 10.875 21.75 11.2108 21.75 11.625V12.375V12.3772C21.7464 13.569 21.2714 14.711 20.4287 15.5537C19.586 16.3964 18.444 16.8714 17.2522 16.875H17.25H7.5C7.08579 16.875 6.75 16.5392 6.75 16.125C6.75 15.7108 7.08579 15.375 7.5 15.375H17.2488C18.0439 15.3723 18.8058 15.0553 19.368 14.493C19.9303 13.9308 20.2473 13.169 20.25 12.374V11.625C20.25 11.2108 20.5858 10.875 21 10.875Z"
                        fill="#28B57A"
                    />
                </svg>
            </div>
        </div>
    );
};
